export default "__VITE_ASSET__DZm57mqc__"